import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
import { init, setSnackBarInfo } from "../js/common_function";
import { clearLocalStorage } from "../js/oauth";
import axios from "axios";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/Home"),
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "로그인",
      },

      component: () => import("../views/Login"),
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "회원가입",
      },
      component: () => import("../views/Register"),
    },
    {
      path: "/siteMap",
      name: "siteMap",
      meta: {
        title: "사이트맵",
      },
      component: () => import("../views/SiteMap"),
    },
    {
      path: "/error",
      name: "error",
      meta: {
        title: "에러페이지",
      },
      component: () => import("../components/error"),
    },
    {
      path: "/Manual",
      name: "Manual",
      meta: {
        title: "매뉴얼",
      },
      component: () => import("../views/Manual"),
    },

    {
      path: "/Finance",
      name: "Finance",
      meta: {
        auth: true,
        title: "경제",
      },
      component: () => import("../views/Finance"),
    },
    {
      path: "/Finance/:id&:sort",
      name: "financeBoardDetail",
      component: () => import("../components/Detail"),
      meta: {
        auth: true,
      },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/RealEstate",
      name: "RealEstate",
      meta: {
        auth: true,
        title: "부동산",
      },
      component: () => import("../views/RealEstate"),
    },
    {
      path: "/RealEstate/:id&:sort",
      name: "realEstateBoardDetail",
      component: () => import("../components/Detail"),
      meta: {
        auth: true,
      },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/VisitorsBook",
      name: "VisitorsBook",
      meta: {
        title: "방명록",
      },
      component: () => import("../views/VisitorsBook"),
    },
    {
      path: "/forum",
      name: "forum",
      meta: {
        auth: true,
        title: "포럼",
      },
      component: () => import("../views/forum"),
      beforeEnter: (to, from, next) => {
        if (
          store.getters.memberType === "MANAGER" ||
          store.getters.memberType === "ADMIN" ||
          store.getters.memberType === "USER"
        ) {
          store.dispatch("PRICE_CHART_DATA_CALL").then((res) => {
            if (res === true) {
              store.dispatch("PRICE_CHART_DATA_CALL").then((response) => {
                // if (response === true) next();
                next();
              });
            }
          });
        } else {
          store.commit("SET_SNACKBAR", setSnackBarInfo("잘못된 경로입니다."));
          next({
            path: "/Home",
          });
        }
      },
    },
    {
      path: "/forum/:id&:sort",
      name: "bulletinBoardDetail",
      component: () => import("../components/Detail"),
      meta: {
        auth: true,
      },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/Humor",
      name: "Humor",
      meta: {
        title: "유머",
      },
      component: () => import("../views/Humor"),
    },
    {
      path: "/Humor/:id&:sort",
      name: "humorDetail",
      component: () => import("../components/Detail"),
      // meta: {
      //   auth: true,
      // },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/Issue",
      name: "todayIssue",
      meta: {
        title: "오늘의이슈",
      },
      component: () => import("../views/todayIssue"),
    },
    {
      path: "/Issue/:id&:sort",
      name: "todayIssueDetail",
      component: () => import("../components/Detail"),
      // meta: {
      //   auth: true,
      // },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/IT",
      name: "IT",
      meta: {
        title: "IT",
        auth: true,
      },
      component: () => import("../views/IT"),
    },
    {
      path: "/IT/:id&:sort",
      name: "ITDetail",
      component: () => import("../components/Detail"),
      meta: {
        auth: true,
      },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/Exercise",
      name: "Exercise",
      meta: {
        title: "운동일지",
      },
      component: () => import("../views/Exercise"),
    },
    {
      path: "/Exercise/:id&:sort",
      name: "ExerciseDetail",
      component: () => import("../components/Detail"),
      // meta: {
      //   auth: true,
      // },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/Travel",
      name: "Travel",
      meta: {
        title: "여행일지",
      },
      component: () => import("../views/Travel"),
    },
    {
      path: "/Travel/:id&:sort",
      name: "TravelDetail",
      component: () => import("../components/Detail"),
      // meta: {
      //   auth: true,
      // },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/Comment",
      name: "Comment",
      meta: {
        title: "감상문",
      },
      component: () => import("../views/Comment"),
    },
    {
      path: "/Comment/:id&:sort",
      name: "CommentDetail",
      component: () => import("../components/Detail"),
      // meta: {
      //   auth: true,
      // },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/BongGu",
      name: "BongGu",
      meta: {
        title: "봉구일지",
      },
      component: () => import("../views/BongGu"),
    },
    {
      path: "/BongGu/:id&:sort",
      name: "BongGuDetail",
      component: () => import("../components/Detail"),
      // meta: {
      //   auth: true,
      // },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/English",
      name: "English",
      meta: {
        title: "언어학습",
      },
      component: () => import("../views/English"),
    },
    {
      path: "/English/:id&:sort",
      name: "EnglishDetail",
      component: () => import("../components/Detail"),
      // meta: {
      //   auth: true,
      // },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/PrivateBulletin",
      name: "PrivateBulletin",
      meta: {
        title: "인규와의 소통",
        auth: true,
      },
      component: () => import("../views/PrivateBulletin"),
    },
    {
      path: "/PrivateBulletin/:id&:sort",
      name: "privateBulletinBoardDetail",
      component: () => import("../components/Detail"),
      meta: {
        auth: true,
      },
      props: (route) => ({
        id: route.params.id,
        sort: route.params.sort,
        readOnly: route.query.readOnly === "true",
      }),
    },
    {
      path: "/ScheduleMng",
      name: "ScheduleMng",
      meta: {
        auth: true,
      },
      component: () => import("../views/ScheduleMng"),
    },
    {
      path: "/LogMonitoring",
      name: "LogMonitoring",
      meta: {
        title: "로그관리",
        auth: true,
      },
      component: () => import("../views/LogMonitoring"),
    },
    {
      path: "/isOkay",
      name: "isOkay",
      meta: {
        auth: true,
      },
      component: () => import("../views/isOkay"),
      beforeEnter: (to, from, next) => {
        if (store.getters.isAuthenticated) {
          if (store.getters.isOkayCheck) {
            next({
              path: "/MyPage",
            });
          } else {
            next();
          }
        } else {
          store.commit("SET_SNACKBAR", setSnackBarInfo("잘못된 경로입니다."));
          next({
            path: "/login",
          });
        }
      },
    },
    {
      meta: {
        title: "마이페이지",
        auth: true,
      },
      path: "/UserManage",
      name: "UserManage",
      meta: {
        title: "회원관리",
        auth: true,
      },
      component: () => import("../views/UserManage"),
      beforeEnter: (to, from, next) => {
        if (
          store.getters.memberType === "MANAGER" ||
          store.getters.memberType === "ADMIN"
        ) {
          store.dispatch("CARD_DATA_CALL").then((res) => {
            if (res === true) {
              store.dispatch("CHART_DATA_CALL").then((response) => {
                // if (response === true) next();
                next();
              });
            }
          });
        } else {
          store.commit("SET_SNACKBAR", setSnackBarInfo("잘못된 경로입니다."));
          next({
            path: "/Home",
          });
        }
      },
    },
    {
      path: "/MyPage",
      name: "MyPage",
      meta: {
        title: "마이페이지",
        auth: true,
      },
      component: () => import("../views/MyPage"),
      beforeEnter: (to, from, next) => {
        if (store.getters.isAuthenticated) {
          next();
        } else {
          store.commit("SET_SNACKBAR", setSnackBarInfo("잘못된 경로입니다."));
          next({
            path: "/login",
          });
        }
      },
    },

    // otherwise redirect to home
    {
      path: "/:anything(.*)",
      redirect: "/error",
    },
  ],
  // scrollBehavior(to, from, savedPosition) {
  //   // const scrollY = to.params?.scrollY === undefined ? 0 : to.params?.scrollY;
  //   console.log(savedPosition);
  //   // console.log(to);
  //   // console.log(from);
  //   if (savedPosition) {
  //     document.savedPosition = savedPosition;
  //     return savedPosition;
  //   } else {
  //     return { y: 1000 };
  //   }
  // },
});

router.beforeEach((to, from, next) => {
  //전 페이지에서 받은 페이지 당 글 개수가 있으면 승계
  if (from.name) {
    if (
      from.name.substring(from.name.length - 6, from.name.length) === "Detail"
    ) {
      if (from.params.perPage) {
        localStorage.setItem("perPage", from.params.perPage);
      } else {
        localStorage.setItem("perPage", 20);
      }
    } else {
      localStorage.setItem("perPage", 20);
    }
  }

  //각각의 페이지에 대한 제목들 설정
  // const ogTitleContent = document.querySelector('meta[property~="og:title"]')
  //   ?.content;
  // const title = to.meta?.title === undefined ? "Darrick World" : to.meta?.title;

  // Vue.nextTick(() => {
  //   if (title) {
  //     document.title = title;
  //     // ogTitle.setAttribute("content", title);
  //     ogTitleContent = title;
  //   } else {
  //     document.title = "Darrick World";
  //   }
  // });

  store.commit("START_SPINNER");
  if (to.matched.some((record) => record.meta.auth)) {
    // this route requires auth, check if logged in if not, redirect to login page.
    if (!store.getters.isAuthenticated) {
      store.commit("SET_SNACKBAR", setSnackBarInfo("로그인이 필요합니다."));
      clearLocalStorage();
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

// router.afterEach((to, from) => {
//   const title =
//     to.params.title === undefined ? "Darrick World" : to.params.title;
//   Vue.nextTick(() => {
//     document.title = title;
//   });
// });

export { router };
